"use strict";

var _classCallCheck = require("/home/im/impactminer/imfrontend/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/im/impactminer/imfrontend/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Records and performs path mappings when different proxies create the
 * same IDs so one's commands need to get remapped.
 */

var PathMapper =
/*#__PURE__*/
function () {
  function PathMapper(mappedPaths) {
    _classCallCheck(this, PathMapper);

    this.mappedPaths = mappedPaths ? mappedPaths : {};
    this.isEmpty = Object.keys(this.mappedPaths).length === 0;
  }

  _createClass(PathMapper, [{
    key: "get",
    value: function get(path) {
      if (this.isEmpty) {
        return undefined;
      }

      var p = path;

      while (p.length > 0) {
        var mappedSection = this.mappedPaths[p.toString()];

        if (mappedSection != undefined) {
          var mappedPath = mappedSection.concat(path.slice(p.length, path.length));
          this.put(path, mappedPath);
          return mappedPath;
        }

        p = p.slice(0, p.length - 1);
      }

      return undefined;
    }
  }, {
    key: "put",
    value: function put(path, remappedPath) {
      this.isEmpty = false;
      this.mappedPaths[path.toString()] = remappedPath;
    }
  }, {
    key: "getMappings",
    value: function getMappings() {
      return this.mappedPaths;
    }
  }]);

  return PathMapper;
}();

exports.PathMapper = PathMapper;